import ReactImageFallback from 'react-image-fallback';
import React from 'react';
import useTranslations from '@hooks/useTranslations';
import { IconTemplate } from '@components/Icon/IconTemplate';
import { Icons } from '@components/Icon';

export interface ITiresDetail {
    subtitle: string;
    label: string;
    description?: string;
    tires: any[];
    className: string;
}

const ModalTiresDetailTemplate = ({ subtitle, label, description, tires, className }: ITiresDetail) => {
    const { t } = useTranslations();

    return (
        <div className={className}>
            <p className="tires-detail__subtitle">{subtitle}</p>
            {label && <h4 className="tires-detail__label">{label}</h4>}
            {description && <p className="tires-detail__description">{description}</p>}
            {tires.length &&
                tires.map((tire, i) => {
                    return (
                        <p key={i}>
                            <ReactImageFallback
                                className="tires-detail__image"
                                src={tire.urlThumbnail}
                                fallbackImage=""
                            />
                            <a href={tire.urlWeb} target="_blank" rel="noreferrer" className="tires-detail__link">
                                {t('technicalFeatures.tiresDetailModal.linkText')}
                                <IconTemplate name={Icons.chevronRightOutlined} width={20} height={12} />
                            </a>
                        </p>
                    );
                })}
        </div>
    );
};

export default ModalTiresDetailTemplate;
